<scrollable>
	@if (!this.usedBrands) {
		<h2>{{ (legalCase ? 'company.legal-case.invoices' : 'company.create-legal-case.invoices-to-hold') | translate }} </h2>
		<skeletons [defaultSkeletons]="2" />
		<h2>{{ (legalCase ? 'company.legal-case.suspended-plans' : 'company.create-legal-case.plans-to-suspend') | translate }} </h2>
		<skeletons [defaultSkeletons]="4" />
	}
	@else {

		@if (usedBrands.length > 1 && !selectedBrand) {
			<h2>{{ 'company.create-legal-case.select-invoice-brand' | translate }} </h2>
			<section>
				@for (brand of usedBrands; track brand.id) {
					<button ghost [loader]="false" (click)="selectedBrand = brand"><icon [attr.brand]="brand.shortName" type="logo" />{{ brand.id | brand }}</button>
				}
			</section>
		}
		@else {
			<h2>{{ (legalCase ? 'company.legal-case.invoices' : 'company.create-legal-case.invoices-to-hold') | translate }} </h2>
			<list-view>
				<header>{{ 'company-invoices.column.ledger-posted-no' | translate }}</header>
				<header>{{ 'company-invoices.column.ledger-type' | translate }}</header>
				<header [defaultSort]="'descending'">{{ 'company-invoices.column.ledger-postingDate' | translate }}</header>
				<header>{{ 'company-invoices.column.ledger-dueDate' | translate }}</header>
				<header align-right>{{ 'company-invoices.column.ledger-value' | translate }}</header>
				<header align-right>{{ 'company-invoices.column.ledger-remaining-value' | translate }}</header>
				<header align-right>{{ 'company-invoices.column.ledger-closed' | translate }}</header>
				<row *listData="let ledgerEntry from invoicesToHold"
						[brand]="ledgerEntry.brandId"
						[clickable]="false">
					<column>{{ ledgerEntry.documentNo }}</column>
					<column>{{ ('company-invoices.bc-document-type.' + bcDocumentType[ledgerEntry.documentType]) | translate }}</column>
					<column [sortValue]="ledgerEntry.postingDate">{{ ledgerEntry.postingDate | customDate: 'shortDate' }}</column>
					<column [sortValue]="ledgerEntry.dueDate">{{ ledgerEntry.dueDate | customDate: 'shortDate' }}</column>
					<column align-right>{{ ledgerEntry.amountInclVat | currency}}</column>
					<column align-right>{{ ledgerEntry.remainingAmountInclVat | currency}}</column>
					<column align-right>{{ (ledgerEntry.open ? 'general.false' : 'general.true') | translate }}</column>
				</row>
			</list-view>
		}

		@if (usedBrands.length > 1 && selectedBrand && suspendAllBrands === undefined && !legalCase) {
			<h2>{{ 'company.create-legal-case.select-plan-suspension-brand' | translate }} </h2>
			<section>
				<button ghost [loader]="false" (click)="suspendAllBrands = false"><icon [attr.brand]="selectedBrand.shortName" type="logo" />{{ 'company.create-legal-case.suspend-plans.only-brand' | translate: { brand: (selectedBrand.id | brand) } }}</button>
				<button ghost [loader]="false" (click)="suspendAllBrands = true">{{ 'company.create-legal-case.suspend-plans.all-brands' | translate }}</button>
			</section>
		}
		@else if (usedBrands.length <= 1 || suspendAllBrands !== undefined || legalCase) {
			<h2>{{ (legalCase ? 'company.legal-case.suspended-plans' : 'company.create-legal-case.plans-to-suspend') | translate }} </h2>
			<list-view>
				<header>{{ 'company.product-plans.product-name' | translate }}</header>
				<header>{{ 'company.accounting-plans.start-date' | translate }}</header>
				<header defaultSort="descending">{{ 'company.accounting-plans.end-date' | translate }}</header>
				<header align-right>{{ 'company.accounting-plans.interval-months' | translate }}</header>
				<header align-right>{{ 'company.accounting-plans.total-value' | translate }}</header>
				<row *listData="let plan from plansToSuspend"
						[brand]="plan.brandId"
						[clickable]="false">
					<column>{{ plan | productName }}</column>
					<column [sortValue]="activeAccountingPlans.get(plan)?.startDate">{{ activeAccountingPlans.get(plan)?.startDate | customDate: 'shortDate' }}</column>
					<column [sortValue]="activeAccountingPlans.get(plan)?.endDate">{{ (plan.autoRenewable ? activeAccountingPlans.get(plan)?.endDate : undefined) | customDate: 'shortDate' }}</column>
					<column align-right>{{ (activeAccountingPlans.get(plan)?.startDate ? activeAccountingPlans.get(plan)?.paymentInterval : plan.paymentScheme) | paymentInterval:{ installments: activeAccountingPlans.get(plan)?.numberOfInstallments, accountingPlan: activeAccountingPlans.get(plan) } }}</column>
					<column align-right [sortValue]="activeAccountingPlans.get(plan)?.totalPlanValue">{{ activeAccountingPlans.get(plan)?.totalPlanValue | currency }}</column>
				</row>
			</list-view>
		}
	}
</scrollable>
<section>
	@if (legalCase) {
		<button #closeCaseButton (click)="closeLegalCase()" [active]="invoicesToHold && legalCaseIsOpen()">{{ 'company.legal-case.close-debt-collection' | translate }}</button>
	}
	@else {
		<button ghost (click)="cancel()">{{ 'general.cancel' | translate }}</button>
		<button confirm (click)="createDebtCollection()" [active]="invoicesToHold && invoicesToHold.length > 0">{{ 'company.create-legal-case.create-debt-collection' | translate }}</button>
	}
</section>
